import PropTypes from 'prop-types';

export const cartItemPropType = PropTypes.shape({
  replacementParts: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string,
      quantity: PropTypes.number,
      price: PropTypes.shape({
        formatted: PropTypes.shape({
          coreCharges: PropTypes.string,
          discountAmount: PropTypes.string,
          discountedPrice: PropTypes.string,
          totalPrice: PropTypes.string,
          undiscountedPrice: PropTypes.string,
          unitPrice: PropTypes.string
        }),
        unformatted: PropTypes.shape({
          coreCharges: PropTypes.number,
          discountAmount: PropTypes.number,
          discountedPrice: PropTypes.number,
          totalPrice: PropTypes.number,
          undiscountedPrice: PropTypes.number,
          unitPrice: PropTypes.number
        })
      }),
      availability: PropTypes.arrayOf(
        PropTypes.shape({
          availabilityMessage: PropTypes.string,
          quantityAvailable: PropTypes.string
        })
      ),
      partLevelFlags: PropTypes.shape({
        isAddToCartEnabled: PropTypes.bool,
        isAlternatePartsExist: PropTypes.bool,
        isCatPart: PropTypes.bool,
        isDealerPartInCatalog: PropTypes.bool,
        isIndirectReplacement: PropTypes.bool,
        isNonReturnable: PropTypes.bool,
        isPartExistInCatalog: PropTypes.bool
      }),

      id: PropTypes.string,
      itemId: PropTypes.string,
      packageQty: PropTypes.string,
      replacementMessage: PropTypes.string,
      sosCode: PropTypes.string,
      weight: PropTypes.string,
      currency: PropTypes.string
    })
  ),
  price: PropTypes.shape({
    formatted: PropTypes.shape({
      coreCharges: PropTypes.string,
      discountAmount: PropTypes.string,
      discountedPrice: PropTypes.string,
      totalPrice: PropTypes.string,
      undiscountedPrice: PropTypes.string,
      unitPrice: PropTypes.string
    }),
    unformatted: PropTypes.shape({
      coreCharges: PropTypes.number,
      discountAmount: PropTypes.number,
      discountedPrice: PropTypes.number,
      totalPrice: PropTypes.number,
      undiscountedPrice: PropTypes.number,
      unitPrice: PropTypes.number
    })
  }),
  partNumber: PropTypes.string,
  partName: PropTypes.string,
  id: PropTypes.string,
  itemId: PropTypes.string,
  packageQty: PropTypes.string,
  replacementMessage: PropTypes.string,
  sosCode: PropTypes.string,
  weight: PropTypes.string,
  quantity: PropTypes.number,
  remanParts: PropTypes.arrayOf(
    PropTypes.shape({
      availability: PropTypes.arrayOf(
        PropTypes.shape({
          availabilityMessage: PropTypes.string,
          quantityAvailable: PropTypes.string
        })
      ),
      id: PropTypes.string,
      itemId: PropTypes.string,
      packageQty: PropTypes.string,
      partLevelFlags: PropTypes.shape({
        isAddToCartEnabled: PropTypes.bool,
        isAlternatePartsExist: PropTypes.bool,
        isCatPart: PropTypes.bool,
        isDealerPartInCatalog: PropTypes.bool,
        isIndirectReplacement: PropTypes.bool,
        isNonReturnable: PropTypes.bool,
        isPartExistInCatalog: PropTypes.bool
      }),
      partNumber: PropTypes.string,
      price: PropTypes.shape({
        formatted: PropTypes.shape({
          coreCharges: PropTypes.string,
          discountAmount: PropTypes.string,
          discountedPrice: PropTypes.string,
          totalPrice: PropTypes.string,
          undiscountedPrice: PropTypes.string,
          unitPrice: PropTypes.string
        }),
        unformatted: PropTypes.shape({
          coreCharges: PropTypes.number,
          discountAmount: PropTypes.number,
          discountedPrice: PropTypes.number,
          totalPrice: PropTypes.number,
          undiscountedPrice: PropTypes.number,
          unitPrice: PropTypes.number
        }),
        quantity: PropTypes.string,
        replacementMessage: PropTypes.string,
        sosCode: PropTypes.string,
        weight: PropTypes.string
      })
    })
  )
});

export const replacementPartsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    partNumber: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.shape({
      formatted: PropTypes.shape({
        coreCharges: PropTypes.string,
        discountAmount: PropTypes.string,
        discountedPrice: PropTypes.string,
        totalPrice: PropTypes.string,
        undiscountedPrice: PropTypes.string,
        unitPrice: PropTypes.string
      }),
      unformatted: PropTypes.shape({
        coreCharges: PropTypes.number,
        discountAmount: PropTypes.number,
        discountedPrice: PropTypes.number,
        totalPrice: PropTypes.number,
        undiscountedPrice: PropTypes.number,
        unitPrice: PropTypes.number
      })
    }),
    availability: PropTypes.arrayOf(
      PropTypes.shape({
        availabilityMessage: PropTypes.string,
        quantityAvailable: PropTypes.string
      })
    ),
    partLevelFlags: PropTypes.shape({
      isAddToCartEnabled: PropTypes.bool,
      isAlternatePartsExist: PropTypes.bool,
      isCatPart: PropTypes.bool,
      isDealerPartInCatalog: PropTypes.bool,
      isIndirectReplacement: PropTypes.bool,
      isNonReturnable: PropTypes.bool,
      isPartExistInCatalog: PropTypes.bool
    }),

    id: PropTypes.string,
    itemId: PropTypes.string,
    packageQty: PropTypes.string,
    replacementMessage: PropTypes.string,
    sosCode: PropTypes.string,
    weight: PropTypes.string,
    currency: PropTypes.string
  })
);
